import React, { useState, useEffect } from 'react';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

function ShareDebug() {
  const { currentUser } = useAuth();
  const [shares, setShares] = useState([]);
  const [ownerEmail, setOwnerEmail] = useState('');
  const [selectedShareId, setSelectedShareId] = useState('');

  useEffect(() => {
    const fetchAllShares = async () => {
      try {
        const sharesRef = collection(db, 'shares');
        const querySnapshot = await getDocs(sharesRef);
        const allShares = [];
        
        querySnapshot.forEach((doc) => {
          allShares.push({
            id: doc.id,
            ...doc.data()
          });
        });
        
        setShares(allShares);
      } catch (error) {
        console.error('Error fetching shares:', error);
      }
    };

    fetchAllShares();
  }, []);

  const updateShare = async () => {
    if (!selectedShareId || !ownerEmail) {
      alert('Please select a share and enter an email');
      return;
    }

    try {
      const shareRef = doc(db, 'shares', selectedShareId);
      await updateDoc(shareRef, {
        ownerEmail: ownerEmail
      });
      
      alert('Share updated successfully');
      
      // Refresh the list
      const sharesRef = collection(db, 'shares');
      const querySnapshot = await getDocs(sharesRef);
      const allShares = [];
      
      querySnapshot.forEach((doc) => {
        allShares.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      setShares(allShares);
    } catch (error) {
      console.error('Error updating share:', error);
      alert('Error updating share');
    }
  };

  if (!currentUser) {
    return <div>Please log in</div>;
  }

  return (
    <div style={{ padding: '20px' }}>
      <h2>Share Debug Tool</h2>
      <p>Current User: {currentUser.email}</p>
      
      <h3>All Shares</h3>
      <table style={{ border: '1px solid black', width: '100%' }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Owner User ID</th>
            <th>Owner Email</th>
            <th>Shared With Email</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {shares.map(share => (
            <tr key={share.id} style={{ backgroundColor: !share.ownerEmail ? '#ffeeee' : 'white' }}>
              <td>{share.id}</td>
              <td>{share.ownerUserId}</td>
              <td>{share.ownerEmail || 'MISSING'}</td>
              <td>{share.sharedWithEmail}</td>
              <td>{share.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <h3>Update Missing Owner Emails</h3>
      <select value={selectedShareId} onChange={(e) => setSelectedShareId(e.target.value)}>
        <option value="">Select a share</option>
        {shares.filter(s => !s.ownerEmail).map(share => (
          <option key={share.id} value={share.id}>
            {share.id} - Shared with: {share.sharedWithEmail}
          </option>
        ))}
      </select>
      
      <input
        type="email"
        placeholder="Enter owner email"
        value={ownerEmail}
        onChange={(e) => setOwnerEmail(e.target.value)}
      />
      
      <button onClick={updateShare}>Update Share</button>
    </div>
  );
}

export default ShareDebug;